<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item label="活动名称：" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="背景图" required prop="background_image">
          <el-upload
            class="avatar-uploader"
            action="/admin-api/invite_new_users_configs/uploadImg"
            name="background_image"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.background_image" :src="form.background_image">
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <!-- <el-input v-model="form.surface"/> -->
        </el-form-item>
        <el-form-item label="需要达成条件" required prop="condition">
          <el-radio v-model="form.condition" :label="condition1" border>实名认证</el-radio>
          <el-radio v-model="form.condition" :label="condition2" border>完成首单</el-radio>
        </el-form-item>
        <el-form-item label="区域" prop="area_id">
          <el-select
            filterable
            clearable
            v-model="form.area_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="活动开始时间" required prop="start_time">
          <el-date-picker
            v-model="form.start_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="活动结束时间" required prop="end_time">
          <el-date-picker
            v-model="form.end_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>

        <el-form-item label="是否启用：" required prop="status">
          <el-radio v-model="form.status" :label="status1" border>启用</el-radio>
          <el-radio v-model="form.status" :label="status0" border>停用</el-radio>
        </el-form-item>

        <el-form-item label="是否可重复任务" required prop="is_repeat">
          <el-radio v-model="form.is_repeat" :label="is_repeat0" border>否</el-radio>
          <el-radio v-model="form.is_repeat" :label="is_repeat1" border>是</el-radio>
        </el-form-item>
        <el-card v-for="(item, index) in form.dynamic_item" :key="index" body-style="padding-left: 0;">
          <el-form-item
            label="需要邀请人数"
            required
            :prop="'dynamic_item.' + index + '.num'"
          >
            <el-input-number
              v-model="item.num"
              :precision="0"
              :step="1"
              :max="100"
            />
          </el-form-item>
          <el-form-item label="赠送类别" required :prop="'dynamic_item.' + index + '.give_type'">
            <el-radio v-model="item.give_type" label="card" border>送骑行卡</el-radio>
            <el-radio v-model="item.give_type" label="coupon" border>送优惠券</el-radio>
            <el-radio v-model="item.give_type" label="balance" border>送余额</el-radio>
          </el-form-item>

          <el-form-item
            v-show="item.give_type == 'card'"
            :prop="'dynamic_item.' + index + '.card_id'"
            required
            label="骑行卡"
          >
            <el-select
              class="limit-width"
              v-model="item.card_id"
              placeholder="请选择"
            >
              <el-option
                v-for="it in cards"
                :key="it.id"
                :label="it.name"
                :value="it.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-show="item.give_type == 'coupon'"
            :prop="'dynamic_item.' + index + '.coupon_id'"
            required
            label="优惠券"
          >
            <el-select
              class="limit-width"
              v-model="item.coupon_id"
              placeholder="请选择"
            >
              <el-option
                v-for="ite in coupons"
                :key="ite.id"
                :label="ite.title"
                :value="ite.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="送券数量："
            v-show="item.give_type == 'coupon'"
            required
            :prop="'dynamic_item.' + index + '.coupon_num'"
          >
            <el-input-number
              v-model="item.coupon_num"
              :min="0"
              :step="1"
              :max="10"
            />
          </el-form-item>

          <el-form-item
            label="赠送余额："
            required
            :prop="'dynamic_item.' + index + '.balance'"
            v-show="item.give_type == 'balance'"
          >
            <el-input-number
              v-model="item.balance"
              :min="0"
              :step="0.01"
              :max="100"
            />
          </el-form-item>
          <el-form-item>
            <el-button v-show="index!==0" @click="deleteItem(item, index)" type="danger">删除</el-button>
          </el-form-item>
        </el-card>
        <el-button @click="addItem" type="warning">增加</el-button>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import { getCoupon } from '@/api/coupon'
import { editInviteNewUsersConfigs, storeInviteNewUsersConfigs, updateInviteNewUsersConfigs } from '@/api/invite-new-users-configs'
import { getAreas } from '@/api/area'
import { getToken } from '@/libs/token'
import { getRidingCard } from '@/api/card-riding'

import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        name: '',
        background_image: '',
        condition: 0,
        dynamic_item: [{
          give_type: '',
          num: 0,
          card_id: '',
          coupon_id: '',
          coupon_num: 0,
          balance: 0,
        }],

        is_repeat: 0,

        start_time: new Date(),
        end_time: new Date(),
        status: 1,
        area_id: '',
      },
      rules: {},
      errors: {},
      areas: [],
      condition1: 1, // 实名认证
      condition2: 2, // 完成首单
      is_give_card0: 0,
      is_give_card1: 1,
      is_give_coupon0: 0,
      is_give_coupon1: 1,
      is_repeat0: 0,
      is_repeat1: 1,
      cards: [],
      coupons: [],
      status1: 1,
      status0: 0,
      uploadHeaders: {
        Authorization: '',
      },
    }
  },
  async created() {
    this.uploadHeaders.Authorization = getToken()
    const [{ data: cards }] = await Promise.all([
      getRidingCard({ all: 1, is_give: 1 }),
    ])

    this.cards = cards

    const { data: coupons } = await getCoupon({ all: 1 })
    this.coupons = coupons
  },
  methods: {
    addItem() {
      this.form.dynamic_item.push({
        give_type: '',
        num: 0,
        card_id: '',
        coupon_id: '',
        coupon_num: 0,
        balance: 0,
      })
    },
    deleteItem(item, index) {
      if (index !== 0) {
        this.form.dynamic_item.splice(index, 1)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateInviteNewUsersConfigs(this.resourceId, this.form)
      } else {
        await storeInviteNewUsersConfigs(this.form)
      }
    },
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = areas

      if (this.editMode) {
        const { data } = await editInviteNewUsersConfigs(this.resourceId)
        // data.areas = data.areas.map(i => i.id)
        this.fillForm(data)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    handleAvatarSuccess(res, file) {
      this.form.background_image = res.path
      // console.log(res)
    },
  },
}
</script>
<style lang="scss" scoped >
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatara {
     /* width: 178px; */
    height: 178px;
    display: block;
  }
</style>
